import { Component, computed, input, signal } from '@angular/core';
import { DetailViewDto } from '@myarvato/modules/transport/models';
import { TranslatePipe } from '@ngx-translate/core';
import { DataFieldComponent } from '@myarvato/shared/data-field';
import { collapseAnimation } from '@myarvato/shared/animations';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { SavePageSizeDirective } from '@myarvato/shared/save-page-size';

@Component({
  selector: 'transport-details-contents',
  imports: [TranslatePipe, DataFieldComponent, TableModule, ButtonModule, SavePageSizeDirective],
  templateUrl: './details-contents.component.html',
  styleUrl: './details-contents.component.scss',
  animations: [collapseAnimation],
})
export class DetailsContentsComponent {
  public readonly details = input.required<DetailViewDto>();
  protected readonly totalQuantity = computed(() => {
    return this.details().contents.contentItems.reduce((acc, item) => acc + +item.amount, 0);
  });

  protected readonly isComponentCollapsed = signal<boolean>(true);
  protected readonly needsPagination = computed(() => this.details()?.contents?.contentItems?.length > 5);

  /**
   * Toggles the collapsed state of the component.
   */
  protected toggleComponentCollapse(): void {
    this.isComponentCollapsed.set(!this.isComponentCollapsed());
  }
}
